import Home from "./Home";
import {useLocation} from "react-router-dom";
import {useEffect} from "react";

export default function WidgetPreview() {
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const wid = params.get('wid');
        const wtype = params.get('wtype');

        const scriptTag = document.createElement("script");
        scriptTag.async = true;

        console.log('wid', wid);
        console.log('wtype', wtype);

        scriptTag.src = "https://widget.chatyar.ir/widget-loader.js";
        scriptTag.setAttribute('data-widget-id', wid);

        document.body.appendChild(scriptTag);

    }, [location]);

    return (<Home/>);
}